'use strict';
angular.module('cvsApp').factory('lookupDemographicalInformationModel',[function() {

    var lookupDemographicalInformationModel = function(){
        var apiResponse = {};        

        this.setResponse = function(data){
            this.apiResponse = data;
        }

        this.getResponse = function(){
            return this.apiResponse;
        }

        this.getError = function(){
            if (this.apiResponse && this.apiResponse.data.statusCode != "0000") {
                this.apiResponse.showError = this.apiResponse
                return this.apiResponse.showError;
            }
            return "";
        }
    }

    return new lookupDemographicalInformationModel();
}]);